import { render, staticRenderFns } from "./ErrorNotifier.vue?vue&type=template&id=b3453462"
import script from "./ErrorNotifier.vue?vue&type=script&lang=js"
export * from "./ErrorNotifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports